import React, { useReducer, useState, useEffect } from 'react';
import {Link, useLocation} from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { menuData } from './Menus';
import { IMAGES } from './theme';
import LanguageSwitcher from '../components/LanguageSwitcher';

interface State {
    active: string;
}

const reducer = (previousState: State, updatedState: Partial<State>): State => ({
    ...previousState,
    ...updatedState,
});

const initialState: State = {
    active: "",
}

interface HeaderProps {}

const Header: React.FC<HeaderProps> = (props) => {
    const { t } = useTranslation();
    const [headerFix, setheaderFix] = useState(false);
    const [toggleMenu, setToggleMenu] = useState(false);
    const [activeMenu, setActiveMenu] = useState('Home');
    const [state, setState] = useReducer(reducer, initialState);

    // Check if we're in development environment
    const isDev = import.meta.env.DEV || window.location.hostname === 'localhost';

    // Handle submenu toggle
    const handleMenuActive = (status: string) => {
      setState({active : status});
      if(state.active === status){
        setState({active : ""});
      }
    }

    // Auto-close menu when clicking on a menu item
    const handleMenuItemClick = (title: string) => {
        // Close mobile menu with smooth transition
        setToggleMenu(false);
        // Reset submenu state
        setState({active: ""});
    }

    /// Path
    let path = useLocation().pathname;

    function CommanScroll(){
        setheaderFix(window.scrollY > 50);
    }

    useEffect(() => {
        menuData.map((data) => {
            if(data.to === path){
                setActiveMenu(data.title);
            }
            data.content?.map((item)=>{
                if(item.to === path){
                    setActiveMenu(data.title)
                }

                return item;

            })
            return data;
        })

        window.addEventListener("scroll", CommanScroll);
        return()=>{
            window.removeEventListener("scroll", CommanScroll)
        }
    },[path, ]);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            const navbar = document.querySelector('.main-navigation');
            const toggleButton = document.querySelector('.toggle-button');

            if (toggleMenu && navbar && !navbar.contains(target) && !toggleButton?.contains(target)) {
                setToggleMenu(false);
                setState({active: ""});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toggleMenu]);

    // Prevent body scroll when mobile menu is open
    useEffect(() => {
        if (toggleMenu) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [toggleMenu]);
    return (
        <>
            <header
                className={`site-header
                ${headerFix ? 'sticky-header' : '' }`}
                style={isDev ? {
                    borderTop: '3px solid #ff6b00',
                    boxShadow: headerFix ? '0 2px 8px rgba(255, 107, 0, 0.15)' : 'none'
                } : {}}
            >
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="header-box">
                                <div className="site-branding">
                                    <Link to={"/"} title="Pure Key Homes">
                                        <img src={IMAGES.logoOneKeyWithOuColor} alt="pure key homes logo 1" />
                                        <img src={IMAGES.logoWithColor} className="sticky-logo" alt="pure key homes logo 2" />
                                    </Link>
                                </div>
                                <div className="header-menu">
                                    <nav className={`main-navigation ${toggleMenu ? 'toggle-menu' : ''}`}>
                                        <button
                                            className={`toggle-button ${toggleMenu ? 'active' : ''}`}
                                            onClick={()=>setToggleMenu(!toggleMenu)}
                                        >
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </button>
                                        <ul className="menu">
                                            {toggleMenu && (
                                                <div className="mobile-menu-header">
                                                    <h3>Menu</h3>
                                                </div>
                                            )}
                                            {menuData.map((item, ind)=>{
                                                if(item.classChange === "sub-items"){
                                                    return(
                                                        <li className={`menu-item ${item.classChange ? "sub-items" : ''}${ item.title === state.active ? " active-sub-menu": ""}${activeMenu === item.title ? ' active' : ''}`}  key={ind}

                                                        >
                                                            <Link
                                                                to={item.to || "#"}
                                                                title={t(item.key)}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleMenuActive(item.title);
                                                                }}
                                                                aria-expanded={state.active === item.title}
                                                                aria-haspopup="true"
                                                                className="menu-link"
                                                            >
                                                                <span>{t(item.key)}</span>
                                                                <svg className="submenu-arrow" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                                                                    <path d="M6 9L2 5h8z"/>
                                                                </svg>
                                                            </Link>
                                                            <Collapse in={state.active === item.title ? true :false}>
                                                                <ul className={`sub-menu ${item.title === state.active ? "d-block": ""}`}
                                                                    role="menu"
                                                                >
                                                                    {item.content && item.content.map((data, index)=>(
                                                                        <li key={index} role="menuitem" className="submenu-item">
                                                                            <Link
                                                                                to={data.to || "#"}
                                                                                title={t(data.key)}
                                                                                onClick={() => handleMenuItemClick(data.title)}
                                                                                className="submenu-link"
                                                                            >
                                                                                {t(data.key)}
                                                                            </Link>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </Collapse>
                                                        </li>
                                                    )
                                                }else{
                                                    return(
                                                        <li className={`menu-item ${ item.title === state.active ? " active-sub-menu": ""}${activeMenu === item.title ? ' active' : ''}`}  key={ind}
                                                        >
                                                            <Link
                                                                to={item.to || "#"}
                                                                title={t(item.key)}
                                                                onClick={() => handleMenuItemClick(item.title)}
                                                                className="menu-link"
                                                            >
                                                                {t(item.key)}
                                                            </Link>
                                                        </li>
                                                    )
                                                }
                                            })}
                                            {toggleMenu && (
                                                <div className="mobile-menu-footer">
                                                    <li className="menu-item login-item">
                                                        <Link
                                                            to="/login"
                                                            title={t('nav.login')}
                                                            onClick={() => handleMenuItemClick('Login')}
                                                            className="login-button"
                                                        >
                                                            {t('nav.login')}
                                                        </Link>
                                                    </li>
                                                    <li className="menu-item language-item">
                                                        <LanguageSwitcher mobile />
                                                    </li>
                                                </div>
                                            )}
                                        </ul>
                                    </nav>
                                    <div className="black-shadow"></div>
                                </div>
                                <div className="header-search" style={{ display: 'flex', alignItems: 'center' }}>
                                    {isDev && (
                                        <div style={{
                                            backgroundColor: '#ff6b00',
                                            color: '#fff',
                                            fontSize: '0.65rem',
                                            fontWeight: '700',
                                            padding: '4px 10px',
                                            borderRadius: '4px',
                                            letterSpacing: '1px',
                                            marginRight: '12px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                            textTransform: 'uppercase'
                                        }}>
                                            DEV
                                        </div>
                                    )}
                                    <LanguageSwitcher isSticky={headerFix} />
                                    <Link to="/login" className="sec-btn" style={{ marginLeft: '15px' }}><span>{t('nav.login')}</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>   
        </>
    );
};

export default Header;